import styled, { StyledComponent } from '@emotion/styled';
import { Chip, ChipProps } from '@mui/material';
import { theme } from 'theme';

interface ChipWrapperProps extends ChipProps {
  selected?: boolean;
  deleteIcon: any;
  fontSize?: string | number;
  fontWeight?:
    | 'bold'
    | 'unset'
    | 'bolder'
    | 'lighter'
    | 'normal'
    | 'inherit'
    | 'initial'
    | 'revert';
  isShowRightIconOnHover?: boolean;
}

export const ChipWrapper: StyledComponent<ChipWrapperProps> = styled(Chip, {
  shouldForwardProp: (prop) =>
    !['fontSize', 'fontWeight', 'selected', 'isShowRightIconOnHover'].includes(
      String(prop),
    ),
})<ChipWrapperProps>`
  font-size: 12px;
  line-height: 16px;
  border-radius: 24px;
  font-weight: ${(props) => (props.selected ? '700' : '400')};
  ${(props) => (props.selected ? '& svg path { stroke-width: 2 }' : '')};
  ${(props) =>
    !Boolean(props.deleteIcon)
      ? 'svg.MuiChip-deleteIcon { display: none !important }'
      : `
   .MuiChip-deleteIcon {
    display: ${props.isShowRightIconOnHover ? 'none' : 'flex'};
    color: ${theme.palette.primary.main} !important;
    &:hover {
      color: ${theme.palette.primary.main} !important;
    }
   }
   &:hover {
     .MuiChip-deleteIcon {
       display: flex !important;
     }
   }
   `};

  &.MuiChip-colorPrimary {
    &:hover {
      background-color: ${theme.palette.grey['A700']};
    }
  }
  &.MuiChip-colorSecondary {
    background-color: ${theme.palette.secondary.main} !important;
    .MuiChip-label {
      color: ${theme.palette.primary.main} !important;
    }
    &:hover {
      background-color: ${theme.palette.secondary.main} !important;
    }
  }

  &.MuiChip-colorDefault {
    border-color: ${theme.palette.grey[300]};
    color: ${theme.palette.grey[600]};
  }
  &.MuiChip-sizeSmall {
    .MuiChip-deleteIcon {
      margin-right: 8px;
    }
  }
  & .MuiChip-deleteIcon {
    margin-right: 8px;
    margin-left: -4px;
    font-size: 11.5px;
    color: inherit;
  }

  & .MuiChip-icon {
    margin-left: 15px;
    font-size: 11.5px;
    color: inherit;
  }

  .MuiIconButton-root {
    padding: 0;
    &:hover,
    &:focus,
    &:active {
      background: transparent;
      box-shadow: none;
    }
  }
  & .MuiChip-label {
    font-weight: ${(props) => props.fontWeight};
    font-size: ${(props) => {
      if (typeof props.fontSize === 'number') {
        return `${props.fontSize}px`;
      } else if (props.fontSize != null) {
        return props.fontSize;
      } else {
        return 'inherit';
      }
    }};
  }
`;
